import { render, staticRenderFns } from "./aside-marketing.vue?vue&type=template&id=6eaa24b3&scoped=true&"
import script from "./aside-marketing.vue?vue&type=script&lang=js&"
export * from "./aside-marketing.vue?vue&type=script&lang=js&"
import style0 from "./aside-marketing.vue?vue&type=style&index=0&id=6eaa24b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eaa24b3",
  null
  
)

export default component.exports